export { default } from "./edgeLabel";
